/** New map quests a free learner may unlock per local calendar day. Retries remain available. */
export const FREE_TIER_DAILY_NEW_QUEST_LIMIT = 1;
